module.exports = __webpack_public_path__ + "assets/img/公众号.cccbbe17.jpg";